import React from 'react';
import { ConfirmationDialog } from '../../../core/components/dialogs/confirmationDialog';
import { Paragraph } from '../../../core';

export interface CancelSchedulingConfirmationDialogProps {
  isOpen: boolean;
  onContinueScheduling: () => void;
  onCancelScheduling: () => void;
}

const CancelSchedulingConfirmationDialog: React.FC<
  CancelSchedulingConfirmationDialogProps
> = (props: CancelSchedulingConfirmationDialogProps) => {
  return (
    <ConfirmationDialog
      title="Are you sure you want to cancel scheduling this appointment?"
      isOpen={props.isOpen}
      confirmCaption="Cancel scheduling"
      onConfirm={props.onCancelScheduling}
      cancelCaption="Continue scheduling"
      onCancel={props.onContinueScheduling}
      maxWidth={350}
    >
      <Paragraph text="You'll lose any changes you've made." />
    </ConfirmationDialog>
  );
};

export default CancelSchedulingConfirmationDialog;
